import basicRest from '../common/CommonRestFunctions'

const baseAgrochemicalUrl = '/agrochemical'

export default {
  getAgrochemicals () {
    return basicRest.executeBasicAxiosGet(baseAgrochemicalUrl + '/list')
  },
  saveAgrochemical (agrochemicalInfo) {
    return basicRest.executeBasicAxiosPost(baseAgrochemicalUrl + '/save', agrochemicalInfo)
  },
  withdrawAgrochemical (withdrawOrder) {
    return basicRest.executeBasicAxiosPost(baseAgrochemicalUrl + '/withdraw', withdrawOrder)
  },
  getWithdrawedAgrochemicals () {
    return basicRest.executeBasicAxiosGet(baseAgrochemicalUrl + '/withdraw')
  },
  deleteAgrochemical (id) {
    return basicRest.executeBasicAxiosRemove(baseAgrochemicalUrl + '/remove/' + id)
  },
  addAgrochemicalStock (item) {
    return basicRest.executeBasicAxiosPost(baseAgrochemicalUrl + '/sum', item)
  },
  getAgrochemicalNamesList () {
    return basicRest.executeBasicAxiosGet(baseAgrochemicalUrl + '/names')
  },
  getAgroApplications () {
    return basicRest.executeBasicAxiosGet(baseAgrochemicalUrl + '/application')
  },
  saveAgroApplication (applicationInfo) {
    return basicRest.executeBasicAxiosPost(baseAgrochemicalUrl + '/application', applicationInfo)
  },
  deleteAgroApplication (id) {
    return basicRest.executeBasicAxiosRemove(baseAgrochemicalUrl + '/application/' + id)
  },
  getApplicationDetails (id) {
    return basicRest.executeBasicAxiosGet(baseAgrochemicalUrl + '/application-detail/' + id)
  },
  saveAgroApplicationDetail (detail) {
    return basicRest.executeBasicAxiosPost(baseAgrochemicalUrl + '/application-detail', detail)
  },
  deleteAgroApplicationDetail (id) {
    return basicRest.executeBasicAxiosRemove(baseAgrochemicalUrl + '/application-detail/' + id)
  }
}
